import Emitter from "./Emitter";

export default class GameJackpotEnd extends Emitter{
    constructor(gb) {
        super(gb);
    }

    TECH4BET_handler(){
        this.emitTop({method: "game.jackpot.ended"});
        this.emitParent({method: "game.jackpot.ended"});
    }

    _default() {
        this.emitTop({ wpgaction: "game.jackpot.ended" });
        this.emitParent({ wpgaction: "game.jackpot.ended" });
        this.emitiOS({ wpgaction: "game.jackpot.ended" });
    }

}